// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"6988":"0ba9faca1eed1297","7120":"92bc0eabfe57289a"}[chunkId] + ".js";
};